<template>
  <q-checkbox
    v-if="!isEditingTranslationModel || !hideWhenTranslating"
    v-bind="$attrs"
    ref="inputComponent"
    :model-value="fieldValue"
    :disable="computedDisable"
    data-test-id="model-form-checkbox"
    @update:model-value="handleInput"
  >
    <untranslatable-field-tooltip v-if="isEditingTranslationAndFieldNotTranslatable" />

    <template
      v-for="slotName in computedSlots"
      #[slotName]="slotProps"
    >
      <slot
        v-bind="slotProps ?? {}"
        :name="slotName"
      />
    </template>
  </q-checkbox>
</template>

<script>
import UntranslatableFieldTooltip from 'src/modules/admin/components/ModelForm/components/UntranslatableFieldTooltip.vue'
import ModelFormFieldMixin from 'src/modules/admin/components/ModelForm/mixins/ModelFormFieldMixin'

export default {
  name: 'ModelFormCheckbox',
  components: {
    UntranslatableFieldTooltip
  },
  mixins: [ModelFormFieldMixin]
}
</script>
